export default function stopAndReceiveBlobAsync(mediaRecorder) {
	return new Promise((resolve) => {
		// eslint-disable-next-line no-param-reassign
		mediaRecorder.ondataavailable = (event) => {
			resolve(event.data);
		};
		mediaRecorder.stop();
	});
}
